var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 centered",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0 centered"},[_c('v-col',{staticClass:"pa-0 ma-0"},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }